import { render, staticRenderFns } from "./MonthlyPrizes.vue?vue&type=template&id=437e77e4&scoped=true&"
import script from "./MonthlyPrizes.vue?vue&type=script&lang=js&"
export * from "./MonthlyPrizes.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyPrizes.vue?vue&type=style&index=0&id=437e77e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437e77e4",
  null
  
)

export default component.exports